import RestInputItem from 'components/RestInput/RestInputItem';
import { Input, Switch, InputNumber } from 'antd';

const WorkTypesForm = (props) => (
  <div {...props}>
    <RestInputItem source="name" header="workingTypes.name" />
    <RestInputItem
      ContentComponent={Input.TextArea}
      source="description"
      header="industries.description"
    />
    <RestInputItem
      ruleType="number"
      ContentComponent={InputNumber}
      source="priority"
      header="industries.priority"
    />
    <RestInputItem
      valuePropName="checked"
      ruleType="boolean"
      ContentComponent={Switch}
      source="isActive"
      header="industries.isActive"
    />
  </div>
);

WorkTypesForm.propTypes = {};

export default WorkTypesForm;
